import * as actionTypes from "./actionTypes";
import {
  getMyBenefitsAPI,
  requestMyBenefitAPI,
  getMyBenefitsHistoricalAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { GET_FULFILLED } from "@icarius-common/medalTable/actionTypes";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("planWithSameCodeAndNameAlreadyExists");
      break;
    case "ERROR_NO_DATE_AVAILABLE":
      errorString = e.response.data.message;
      break;
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationErrorAltRequests");
      break;
    case "ERROR_DAYS_QUANTITY":
      errorString = getLocalizedString("errorDaysQuantityRequests");
      break;
    case "ERROR_FORMAT_DATES":
      errorString = getLocalizedString("formatDateErrorRequests");
      break;
    case "ERROR_DATES":
      errorString = getLocalizedString("dateErrorRequests");
      break;
    case "ERROR_OVERLAP":
      errorString = getLocalizedString("overlapErrorRequests");
      break;
    case "ERROR_EXISTS":
      errorString = getLocalizedString("youHaveASubmissionWithPendingDocumentationApproval");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getMyBenefitsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getMyBenefitsAPI();

    let data = response.data && response.data.data;
    let consent = response.data && response.data.consent;
    let recipientsList = response.data && response.data.recipientsList;
    let exchangeForMoneyData = response.data && response.data.exchangeForMoneyData;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: {
        data,
        consent,
        recipientsList,
        exchangeForMoneyData,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const requestMyBenefitAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.REQUEST });
  try {
    let response = await requestMyBenefitAPI(dataToSend);

    let data = response.data && response.data.data;
    let consent = response.data && response.data.consent;
    let recipientsList = response.data && response.data.recipientsList;
    let exchangeForMoneyData = response.data && response.data.exchangeForMoneyData;
    let medalTableData = response.data && response.data.medalTableData;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.REQUEST_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.REQUEST_FULFILLED,
      payload: {
        data,
        consent,
        recipientsList,
        exchangeForMoneyData,
      },
    });

    dispatch({
      type: GET_FULFILLED,
      payload: { data: medalTableData },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("benefitRequestProcessedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.REQUEST_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const getMyBenefitsHistoricalAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_HISTORICAL });
  try {
    let response = await getMyBenefitsHistoricalAPI();

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_HISTORICAL_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_HISTORICAL_FULFILLED,
      payload: {
        data,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_HISTORICAL_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};